<template>
    <div>
        <!-- Modal de Assinatura de Requisição -->
        <div class="modal fade" id="assinarRequisicaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="requisicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Requisição</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="card">
                            <div class="card-body">
                                <celula-dados-paciente :hor="{ marcacao: atendimento }" />
                                <hr>
                                <celula-dados-procedimento :hor="dados_procedimento(requisicao.anamnese)" />
                                <hr>
                                {{ $util.getFormatDate(atendimento.dt_inicio) }}
                            </div>
                        </div>

                        <order-set-view 
                            :dados="[requisicao]"
                            type="requisicao"
                            @imprimir="imprimir_receita"
                            @refresh="$emit('refresh')"
                            @assinar="$store.state.user.medico ? true : false"
                            :atendimento="atendimento" />

                        <template v-if="false">
                            <hr>
                            <pre class="alert alert-warning">{{ atendimento }}</pre>
                            <pre class="alert alert-info">{{ requisicao }}</pre>
                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery'; 
import OrderSetView from './OrderSetView.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import CelulaDadosProcedimento from '../../shared/table/CelulaDadosProcedimento.vue';

export default {
    data() { 
        return { 
            requisicao: null, 
            atendimento: null, 
        }
    },
    
    components: { 
        OrderSetView, 
        CelulaDadosPaciente, 
        CelulaDadosProcedimento, 
    },

    methods: { 
        abrir (requisicao, atendimento) { 
            this.atendimento = _.cloneDeep(atendimento);
            this.requisicao = _.cloneDeep(requisicao);

            $('#assinarRequisicaoModal').modal('show');
        },

        dados_procedimento(laudo) { 
            return { 
                marcacao: { 
                    procedimento: laudo.atendimento_procedimento.procedimento,
                    medico: laudo.atendimento_procedimento.atendimento.medico, 
                    arquivos: laudo.atendimento_procedimento.atendimento.marcacao
                        ? laudo.atendimento_procedimento.atendimento.marcacao.arquivos
                        : [],
                    doc_pre_atends: laudo.atendimento_procedimento.atendimento.marcacao
                        ? laudo.atendimento_procedimento.atendimento.marcacao.doc_pre_atends
                        : [], 
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao
                        ? laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao
                        : null, 
                }
            };
        },
    }
}
</script>
